
import { Component, Prop, Vue } from 'vue-property-decorator'
import { OptionCategoryApiModel } from '@/interfaces/OptionCategoryApiModel.js'
import lodash from 'lodash'

@Component
export default class Categories extends Vue {
  @Prop({ default: [] }) readonly categoryList!: Array<OptionCategoryApiModel>
  @Prop({ default: 0 }) readonly activeCategoryId!: number
  @Prop({ default: false }) readonly showToggleOptions!: boolean

  public showMobileNav = false

  public showOtherOptions = false

  public toggleMobileSections() {
    this.showMobileNav = !this.showMobileNav
  }

  public toggleMobileOptions() {
    this.showOtherOptions = !this.showOtherOptions
    this.$emit('toggleOptions', this.showOtherOptions)
  }

  public selectCategory(optionCategory: OptionCategoryApiModel) {
    this.toggleMobileSections()
    this.$emit('click', optionCategory)
  }

  get selectedCategoryName() {
    const category = lodash.find(this.categoryList, { id: this.activeCategoryId })
    if (category === undefined) {
      return ''
    }
    return category.name
  }
}
